import i18n from '@dms/i18n';

import {useVehicleFormContext} from '../hooks/useVehicleFormContext';
import {Field} from './primitives/Field';

export const DimensionLengthSelect = () => {
  const {catalogueApi} = useVehicleFormContext();
  return (
    <Field
      name="lengthCategory"
      options={catalogueApi?.dimensionsLengthOptions ?? []}
      type="choice"
      label={i18n.t('entity.vehicle.labels.vehicleLength')}
    />
  );
};
